export enum ChannelType {
  LISTEN_ONLY_CHANNEL = 'ListenOnlyChannel',
  INTERCOM_CHANNEL = 'IntercomChannel',
}

export enum SourceType {
  PORTABLE_SOURCE = 'PortableSource',
  INTERFACE_SOURCE = 'InterfaceSource',
}
